// extracted by mini-css-extract-plugin
export var blue = "_37-f";
export var brand = "_37-b";
export var darkGrey = "_37-e";
export var disabled = "_37-4";
export var disabledSubtle = "_37-5";
export var error = "_37-6";
export var green = "_37-g";
export var grey = "_37-d";
export var icon = "_37-0";
export var inherit = "_37-a";
export var lightGrey = "_37-c";
export var orange = "_37-i";
export var pink = "_37-k";
export var primary = "_37-1";
export var purple = "_37-l";
export var red = "_37-j";
export var secondary = "_37-2";
export var success = "_37-9";
export var tertiary = "_37-3";
export var warning = "_37-7";
export var warningSecondary = "_37-8";
export var white = "_37-m";
export var yellow = "_37-h";